// Tutorials (Masterplan Paket 6): zentrale Tour-Definitionen. Texte kommen aus dem i18n-Namespace
// "tours" (tours:<id>.<step>.title/body). Anker sind data-tour-Attribute im Markup; Schritte, deren
// Element auf der aktuellen Seite/Umgebung nicht sichtbar ist (z. B. Sidebar auf Mobile, auf Prod
// ausgeblendete Kategorien), werden beim Start automatisch uebersprungen.

export type TourId = 'welcome' | 'chat' | 'generation' | 'imageStudio';

export interface TourStepDef {
    // CSS-Selektor des Ankers; fehlt = zentrierter Hinweis ohne Hervorhebung
    element?: string;
    key: string;
    side?: 'top' | 'bottom' | 'left' | 'right';
}

export const TOURS: Record<TourId, TourStepDef[]> = {
    welcome: [
        { key: 'intro' },
        { element: '[data-tour="nav-/chat"]', key: 'chat', side: 'right' },
        { element: '[data-tour="nav-/apps/knowledge"]', key: 'knowledge', side: 'right' },
        { element: '[data-tour="nav-/apps/creativity"]', key: 'creativity', side: 'right' },
        { element: '[data-tour="nav-/apps/tools"]', key: 'tools', side: 'right' },
        { element: '[data-tour="sidebar-toggle"]', key: 'sidebarToggle', side: 'bottom' },
        { element: '[data-tour="platform-status"]', key: 'status', side: 'bottom' },
        { element: '[data-tour="user-menu"]', key: 'userMenu', side: 'bottom' },
        { element: '[data-tour="platform-version"]', key: 'version', side: 'top' },
    ],
    chat: [
        { element: '[data-tour="chat-history"]', key: 'history', side: 'right' },
        { element: '[data-tour="chat-input"]', key: 'input', side: 'top' },
    ],
    generation: [
        { element: '[data-tour="prompt-area"]', key: 'prompt', side: 'bottom' },
        { element: '[data-tour="generate-button"]', key: 'generate', side: 'left' },
        { element: '[data-tour="generation-settings"]', key: 'settings', side: 'top' },
    ],
    imageStudio: [
        { key: 'intro' },
        { element: '[data-tour="studio-settings"]', key: 'settings', side: 'right' },
        { element: '[data-tour="studio-canvas"]', key: 'canvas', side: 'left' },
        { element: '[data-tour="studio-toolbar"]', key: 'toolbar', side: 'top' },
        { element: '[data-tour="studio-layers"]', key: 'layers', side: 'left' },
        { element: '[data-tour="studio-gallery"]', key: 'gallery', side: 'top' },
    ],
};

// Welche Tool-Tour zu welcher Route gehoert. Alle einfachen Generierungs-Apps teilen sich die
// Komponenten PromptArea/SettingAIOptions und damit auch eine Tour.
const GENERATION_ROUTES = ['/executions/2', '/executions/3', '/executions/6', '/executions/7', '/executions/12', '/executions/13'];

export const getTourForPath = (pathname: string): TourId | null => {
    if (pathname === '/chat' || pathname.startsWith('/chat/')) return 'chat';
    if (GENERATION_ROUTES.includes(pathname)) return 'generation';
    if (pathname === '/executions/14') return 'imageStudio';
    return null;
};
